import { render, staticRenderFns } from "./CollapseTag.vue?vue&type=template&id=5cd17e3a&scoped=true&"
import script from "./CollapseTag.vue?vue&type=script&lang=js&"
export * from "./CollapseTag.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTag.vue?vue&type=style&index=0&id=5cd17e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd17e3a",
  null
  
)

export default component.exports